var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trailing-icon",
    clipPath: "url(#lockIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 13.2857C11.0375 13.2857 10.25 14.0571 10.25 15C10.25 15.9429 11.0375 16.7143 12 16.7143C12.9625 16.7143 13.75 15.9429 13.75 15C13.75 14.0571 12.9625 13.2857 12 13.2857ZM17.25 9H16.375V7.28571C16.375 4.92 14.415 3 12 3C10.005 3 8.26375 4.32 7.765 6.21429C7.6425 6.67714 7.9225 7.14 8.395 7.26C8.85875 7.38 9.34 7.10571 9.4625 6.64286C9.76 5.51143 10.8012 4.71429 12 4.71429C13.4438 4.71429 14.625 5.87143 14.625 7.28571V9H6.75C5.7875 9 5 9.77143 5 10.7143V19.2857C5 20.2286 5.7875 21 6.75 21H17.25C18.2125 21 19 20.2286 19 19.2857V10.7143C19 9.77143 18.2125 9 17.25 9ZM17.25 18.4286C17.25 18.9 16.8562 19.2857 16.375 19.2857H7.625C7.14375 19.2857 6.75 18.9 6.75 18.4286V11.5714C6.75 11.1 7.14375 10.7143 7.625 10.7143H16.375C16.8562 10.7143 17.25 11.1 17.25 11.5714V18.4286Z",
    fill: "#295BB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lockIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.e394f6284065c4b33f2ce8c2dfa22367.svg";
export { ForwardRef as ReactComponent };